var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.serverList, function(server) {
      return _c("div", [
        _c(
          "a",
          {
            attrs: {
              href: _vm.$laroute.route("reports_show", {
                server_id: server.entity_id
              }),
              title: "View Reports"
            }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(server.entity_name) +
                " / " +
                _vm._s(server.server_name) +
                " ( " +
                _vm._s(server.server_ip) +
                " )\n            load: " +
                _vm._s(server.load_1) +
                ", " +
                _vm._s(server.load_5) +
                ", " +
                _vm._s(server.load_15) +
                "\n            (" +
                _vm._s(_vm.elapsedTime(server.load_time)) +
                ")\n        "
            )
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }